import Vue from 'vue'
import _router from 'vue-router'
import store from '../vuex'
import LocalStore from '../fscommon/utils/localstore'

Vue.use(_router) //应用路由

const router = new _router({
    routes: [
        { path: '/login',  component: resolve => require(['../views/auth/login'], resolve),
        },
        {  path: '/register',  component: resolve => require(['../views/auth/register'], resolve),
        },


        {  path: '/',  component: resolve => require(['../views/index'], resolve),
            meta: { showHeader: true, showTabBar: true, requireAuth: true }
        },
        {  path: '/contact',  component: resolve => require(['../views/contact'], resolve),
            meta: { showHeader: true, showTabBar: true, requireAuth: true },
        },
        {  path: '/contact/uinfo',  component: resolve => require(['../views/contact/uinfo'], resolve),
        },
        {  path: '/ucenter', component: resolve => require(['../views/ucenter'], resolve),
            meta: { showHeader: true, showTabBar: true, requireAuth: true }
        },


        {  path: '/chat/group-chat', component: resolve => require(['../views/chat/group-chat'], resolve),
            meta: { requireAuth: true }
        },
        {  path: '/chat/single-chat',  component: resolve => require(['../views/chat/single-chat'], resolve),
            meta: { requireAuth: true }
        },
        { path: '/chat/group-info', component: resolve => require(['../views/chat/group-info'], resolve),
            meta: { requireAuth: true }
        }

        // ...
    ]
})

// 拦截登录状态
// const that = this
// router.beforeEach((to, from, next) => {
//     const token = store.state.token
//     if(to.meta.requireAuth){ if(token){ next()
//         }else{
//             next()
//              wcPop({ content: '还未登录授权！', style: 'background:#e03b30;color:#fff;', time: 2,end: function(){ next({ path: '/login' }) }
//             });
//         }
//     }else{  next()
//     }
// })


const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  var token = LocalStore.getToken();
  console.log('match route token '+token+" to "+to.path +" from "+from.path +" next "+next.path);
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
        next();
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js